
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import Moment from "react-moment";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { daysDiffernce, daysDiffernceWithMinOne } from "@utils/utils";
import { toast } from "react-toastify";
import { createLogs } from "@store/slices/PropertyData";
import { loginSuccess } from "@store/slices/authenticationSlice";
import OTPInput from "react-otp-input";
import ReactGA from "react-ga4";
import { getTaxService } from "@api/services/newServices";
import axios from "axios";
import Swal from "sweetalert2";
import { authenticationSeletor } from "@store/slices/authenticationSlice";
import services from "@api/services";
import { FaRegEdit } from "react-icons/fa";
import ImagesData from '@assets/ImagesData';
import { IoLocationOutline } from '@assets/Icons';
import { FOOD_PLAN } from '@constant/constants'

const meal_Modes = { ep: 0, breakFastPrice: 1, ap: 2, map: 3 };

const Bookhotel = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const hotelData = JSON.parse(localStorage.getItem('hotelData'))
    const categoryDatas = JSON.parse(localStorage.getItem('categoryData'))
    const hotelId = 107
    const todayMoment = moment();
    const tomorrowMoment = todayMoment.clone().add(1, "days");
    const { userDetail, access_token } = useSelector(authenticationSeletor);
    const [bookingData, setBookingData] = useState({ room: 1, adults: 1, children: 0 });
    const [checkinDate, setCheckinDate] = useState(new Date(todayMoment));
    const [categoryData, setCategoryData] = useState([]);
    const [checkOutDate, setCheckOutDate] = useState(new Date(hotelData?.slot >= 24 ? tomorrowMoment.toDate() : todayMoment.toDate()));
    const [inputCouponCode, setInputCouponCode] = useState("");
    const [hoterData, setHotelData] = useState({});
    const [showPayment, setShowPayment] = useState(true);
    const [anotherPerson, setAnotherPerson] = useState(false);
    const [selectedPayOptipn, setSelectedPayOptipn] = useState("");
    const [couponCode, setCouponCode] = useState({});
    const [couponAmount, removeCouponAmount] = useState("");
    const [bookingDetail, setBookingDetail] = useState("");
    const [fetchCoupon, setFetchCoupon] = useState([]);
    const [tax, setTax] = useState({});
    const [cancelBulk, setCencelBulk] = useState(false);
    const [withValidation, setWithValidation] = useState({});
    const [cpnShow, setCpnShow] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [breakFastCharge, setBreakFastCharge] = useState(false);
    const [roomBreakFastPrice, setRoomBreakFastPrice] = useState({ breakFastPrice: hotelData?.breakFastPrice, ap: hotelData?.ap, map: hotelData?.map });
    const [cuponCode, setCuponCode] = useState("");
    const [mealPlan, setMealPlan] = useState("ep");
    const [breakFastMoney, setBreakFastMoney] = useState(0);
    const [sendHours, setSendHours] = useState(hotelData?.slot);
    const [finalShowAmount, setFinalShowAmount] = useState(0);
    const [payloadData, setPayloadData] = useState({});
    const [showScreen, setShowScreen] = useState({ newuser: false, otpScreen: false });
    const [resendOtp, setResendOtp] = useState(false);
    const [otp, setOtp] = useState("");
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [fakePrice, setFakePrice] = useState(0);
    const [count, setCount] = useState(1);
    const [counter, setCounter] = useState(30);
    const [countRoom, setCountRoom] = useState(1);
    const [countChild, setCountChild] = useState(0);
    const [totalAvilableRoom, setTotalAvilableRoom] = useState(hotelData?.avilableRoomCount);
    const [newCheckinTime, setNewCheckinTime] = useState(hotelData?.selectedCheckinTime)
    const [availRooms, setAvailRooms] = useState(0)

    const timerForOtp = () => {
        const countRef = setTimeout(() => { setCounter(() => counter - 1) }, 1000);
        if (counter <= 0) {
            clearTimeout(countRef);
            setResendOtp(true);
        }
    };

    useEffect(() => { if (showScreen.otpScreen) { timerForOtp(); } }, [showScreen, counter]);

    const resendOTP = async (e) => {
        e.preventDefault();
        try {
            const res = await services.auth.userLogin({ mobile: payloadData.phoneNumber });
            if (res.status == 200) {
                toast.success(`OTP resend on ${payloadData.phoneNumber}*`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
                setCounter(30);
                setResendOtp(false);
            }
        } catch (error) { console.log("Error in resendOTP function.") }
    };

    useEffect(() => { window.scrollTo(0, 0) }, []);

    const verifyHandler = async (e) => {
        e.preventDefault()
        let payloadMain = {};
        if (otp.length < 4) {
            toast.error("Please Enter OTP*", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
            return;
        }
        payloadMain = {
            mobile: payloadData.mobile,
            name: payloadData.name,
            email: payloadData.email,
            otp: otp,
            platform: 1,
        };
        try {
            const res = await services.auth.userVerify(payloadMain);
            if (res.status == 200 && res.data.success === true) {
                if (res?.data?.data.name && res?.data?.data.email) {
                    dispatch(loginSuccess({ data: { ...res?.data?.data, logintype: "normalUser" }, token: res?.data?.token }));
                    setShowScreen({ newuser: false, otpScreen: false })
                } else {
                    const { createdAt, deletedAt, id, lastLogged, mobile, otp, password, updatedAt } = res?.data?.data;
                    const { name, email } = payloadMain;
                    dispatch(loginSuccess({
                        data: { createdAt, deletedAt, id, name, email, lastLogged, mobile, otp, password, updatedAt, logintype: "normalUser" },
                        token: res?.data?.token,
                    }));
                }
            }
        } catch (error) {
            if (error.response.status == 400) { toast.error("Wrong OTP*", { autoClose: 2000, pauseOnHover: true }); }
        }
    };

    const getRoomsById = async (id) => {
        try {
            const res = await services.globalService.getRoomByIdService(id);
            if (res.status == 200) { navigate(`/hotel-details/${res.data.data.propertyId}`); }
        } catch (error) { console.log("Error in getRoomsById function.") }
    };

    useEffect(() => {
        if (!!hotelData) {
            setHotelData(hotelData);
            getTaxApi();
            getCoupan();
            setSendHours(hotelData?.slot);
            setRoomBreakFastPrice({ breakFastPrice: hotelData?.breakFastPrice, ap: hotelData?.ap, map: hotelData?.map });
        }
        else { if (hotelId) { getRoomsById(hotelId); } }
    }, []);

    useEffect(() => {
        if (!userDetail?.name && access_token) {
            Swal.fire({
                title: "Update Profile",
                text: "Please update your profile to complete your booking.",
                icon: "question",
            }).then((result) => { navigate("/user-profile"); });
        }
    }, [userDetail, access_token]);

    useEffect(() => {
        if (access_token) { setWithValidation({ mode: "onSubmit" }); }
        else {
            // setWithValidation({ ...validation, mode: "onSubmit" });
        }
    }, [access_token]);

    const { register, handleSubmit, setFocus, formState: { errors } } = useForm();

    function getBookingRange(startTime, bookingSlot) {
        const hours = parseInt(bookingSlot, 10);
        const [h, m] = startTime.split(":").map(Number);
        const start = new Date();
        start.setHours(h);
        start.setMinutes(m);
        const end = new Date(start.getTime() + hours * 60 * 60 * 1000);
        const pad = (n) => String(n).padStart(2, "0");
        const endStr = `${pad(end.getHours())}:${pad(end.getMinutes())}`;
        return `${startTime} to ${endStr}`;
    }

    const onSubmit = async (payload) => { if (access_token) { bookHotalHandler(payload); } };

    const bookHotalHandler = async (payload, id) => {
        if (totalAvilableRoom == 0) {
            toast.error('No Room Available. Please select another checkin date or time.');
            return
        }
        let payTotal = Math.round(finalShowAmount + (finalShowAmount * tax?.amount) / 100);
        let realPayload = {
            propertyId: hoterData.propertyId,
            propertyRoomsCategoryId: hoterData.categoryId,
            userId: userDetail.id,
            fromDate: moment(checkinDate).format("YYYY-MM-DD"),
            noOfRooms: bookingData.room,
            adults: bookingData.adults,
            children: bookingData.children,
            paymentMode: 0,
            PaymentStatus: 0,
            bookingStatus: 0,
            // checkInDateTime: checkinDate,
            // checkOutDateTime: checkOutDate,
            bookingAmout: payTotal,
            dueAmount: payTotal,
            guestDetails: [],
            otherPersonName: userDetail?.logintype == "normalUser" ? payload.otherPersonName : userDetail?.name,
            otherPersonNumber: payload.otherPersonNumber,
            source: "RRooms",
            breakFast: meal_Modes[mealPlan],
            bookingHours: sendHours,
            discountAmount: Math.round(couponAmount),
            platform: 1,
        };
        if (hotelData?.slot == '24') {
            realPayload.bookingType = 'Daily'
            realPayload.toDate = moment(checkOutDate).format("YYYY-MM-DD")
        }
        if (hotelData?.slot != '24') {
            realPayload.bookingSlot = hotelData?.slot?.slice(0, 3)
            realPayload.bookingType = 'Hourly'
            realPayload.bookingHours = getBookingRange(newCheckinTime, hotelData?.slot)
            const slotHours = parseInt(hotelData.slot, 10);
            let bookingHours = realPayload.bookingHours
            const [, endTime] = bookingHours.split(" to ");
            if (endTime == "00:00") { realPayload.bookingHours = `${bookingHours.split(" to ")[0]} to 23:59`; }
            const checkInMoment = moment(`${moment(checkOutDate).format("YYYY-MM-DD")} ${bookingHours.split(" to ")[0]}`, "YYYY-MM-DD HH:mm");
            const checkOutMoment = checkInMoment.clone().add(slotHours, "hours");
            realPayload.toDate = endTime == "00:00" ? moment(checkinDate).format("YYYY-MM-DD") : checkOutMoment.format("YYYY-MM-DD");
        }
        try {
            const res = await services.property.bookHotelService(realPayload);
            if (res.status == 200) {
                const params = {
                    action: `Booking Created - Booking Amount (${payTotal}) - Rooms (${bookingData.room}) - Adults (${bookingData.adults}) - Children (${bookingData.children}) - Meal Plan (${FOOD_PLAN[meal_Modes[mealPlan]]}) - Booking Type (${hotelData?.slot == '24' ? 'Fullday' : 'Hourly'})`,
                    actionBy: 'Guest',
                    activityType: "Booking Created",
                    bookingId: res.data.data?.id,
                    paymentMode: null,
                    propertyId: hotelData?.propertyId,
                    userType: "Guest",
                };
                dispatch(createLogs(params));
                setBookingDetail(res?.data?.data);
            }
        } catch (error) { console.log("Error in bookHotelHandler function.") }
    };


    const changeHandler = (e) => { setBookingData({ ...bookingData, [e.target.name]: e.target.value }); };

    const changeCounts = (state, minVal, countTemp, setFun, countType) => {
        let rooms = countRoom;
        if (hotelData?.bookingType == "Hourly" && state == "up" && countType == "room") {
            const checkRoom = async () => {
                let res = await handleCheckRoomAvilablty(newCheckinTime);
                if (res?.availableRooms == bookingData?.room) { alert('No more Rooms Available') }
            }
            checkRoom()
        }
        if (hotelData?.bookingType != "Hourly" && state == "up" && countType === "room") {
            checkFullDayRoomAvaility()
            if (availRooms?.availableRooms == bookingData?.room) {
                alert('No More Rooms Available')
                return
            }
        }
        if (state == "up") {
            if (
                countType == "room" && countRoom < 5 && hoterData.RoomDetails.length > countRoom) {
                setFun(++countTemp);
            } else if (countType == "adult") {
                if (countTemp < 10 && countTemp < hoterData.RoomDetails.length * 2) {
                    setFun(++countTemp);
                    if (countTemp > countRoom * 2) { setCountRoom(++rooms); }
                }
            } else if (countType == "child") {
                if (countTemp < 10 && countRoom * 2 > countTemp) {
                    setFun(++countTemp);
                    if (countTemp > countRoom * 2) { setCountRoom(++rooms); }
                }
            }
        } else {
            if (countTemp > minVal) setFun(--countTemp);
            if (countType == "adult") {
                if (countTemp + 1 < countRoom * 2) {
                    setCountRoom(--rooms);
                    if (countChild > minVal) {
                        if (countChild == countRoom * 2) {
                            let tempdata = countChild - 2;
                            setCountChild(tempdata);
                        } else {
                            let tempdata = countChild;
                            setCountChild(--tempdata);
                        }
                    }
                }
            } else if (countType == "room") {
                if (count > countTemp * 2) {
                    if (count == countRoom * 2) {
                        let tempdata = count - 2;
                        setCount(tempdata);
                    } else {
                        let tempdata = count;
                        setCount(--tempdata);
                    }
                }
                if (countChild > countTemp * 2) {
                    if (countChild == countRoom * 2) {
                        let tempdata = countChild - 2;
                        setCountChild(tempdata);
                    } else {
                        let tempdata = countChild;
                        setCountChild(--tempdata);
                    }
                }
            }
        }
    };

    useEffect(() => { setBookingData({ room: countRoom, adults: count, children: countChild }); }, [count, countChild, countRoom]);

    const bookHandler = async (option) => {
        try {
            let paymentType = option === "online" && 'Full' || option === "parcialpay" && 'Partial'
            if (option == "online" || option == "parcialpay") {
                const res = await services.property.paymentGateway(bookingDetail?.id, paymentType)
                openRazorpay(res?.data?.data?.order_id, res?.data?.data?.amount, paymentType, bookingDetail?.id, option)
            } else {
                const bookRes = await services.property.updateBookingModeStatus(
                    bookingDetail?.id,
                    {
                        status: 1,
                        paymentMode: option === "online" && 1 || option === "parcialpay" && 1 || option === "PayatHotel" && 0,
                        paymentAmount: paymentType
                    }
                );
                navigate(`/booking-confirm/${bookingDetail?.id}`);
            }
        } catch (error) { console.log("Erro in bookHan") }
    };

    const openRazorpay = async (orderId, amount, paymentType, bookingId, option) => {
        let db_amount = amount / 100
        const options = {
            key: 'rzp_live_Eqmw0XU2XIG31l',
            amount: amount,
            currency: "INR",
            name: "RROOMS",
            description: "RRooms Hotel Booking Payment",
            image: "https://rrooms.in/logo.webp",
            order_id: orderId,
            handler: async function (response) {
                let newRes = await axios.post(`https://staging.rrooms.in/rrooms/api/rrooms-property/razorpay-status-update?booking_id=${bookingId}&paymentType=${paymentType}&paidAmount=${db_amount}&userId=${userDetail?.id}&dueAmount=${paymentType == 'Full ' ? 0 : bookingDetail?.dueAmount - db_amount} `, {
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                });

                if (newRes.status === 200) {
                    let paymentType = option === "online" && 'Full' || option === "parcialpay" && 'Partial'
                    const bookRes = await services.property.updateBookingModeStatus(
                        bookingDetail?.id,
                        {
                            status: 1,
                            paymentMode: option === "online" && 1 || option === "parcialpay" && 1 || option === "PayatHotel" && 0,
                            paymentAmount: paymentType
                        }
                    );
                    navigate(`/booking-confirm/${bookingDetail?.id}`);
                }
            },
            prefill: { name: userDetail?.name, email: userDetail?.email, contact: userDetail?.mobile },
            theme: { color: "#fb961b" },
            modal: {
                ondismiss: function () {
                }
            }
        };
        const rzp = new window.Razorpay(options);
        rzp.open();
    };

    useEffect(() => { if (bookingDetail?.id && paymentMethod) { bookHandler(paymentMethod); } }, [bookingDetail?.id, paymentMethod]);

    const onSubmitCoupon = async (e, code) => {
        e.preventDefault();
        if (code != "") {
            if (fetchCoupon.find((i) => i.code.toLowerCase() == code?.toLowerCase())?.code) {
                const payload = { coupon: code, propertyId: hoterData?.propertyId };
                try {
                    let cAmount = 0;
                    const res = await services.globalService.applyCouponService(payload);
                    if (res.status == 200) {
                        const prtDiscount = JSON.parse(res?.data?.data?.updatedPrice ?? "[]");
                        if (res?.data?.data?.amount) {
                            setCouponCode(res.data.data);
                            if (prtDiscount?.length > 0) {
                                const ifPropertyChange = prtDiscount?.find((i) => i.property_id == hoterData?.propertyId);
                                if (ifPropertyChange) {
                                    cAmount =
                                        (finalShowAmount * Number(prtDiscount?.find((i) => i.property_id == hoterData?.propertyId)?.price)) / 100;
                                } else {
                                    cAmount = (finalShowAmount * Number(res?.data?.data?.amount)) / 100;
                                }
                                removeCouponAmount(cAmount);
                            } else {
                                cAmount = (finalShowAmount * Number(res?.data?.data?.amount)) / 100;
                                removeCouponAmount(cAmount);
                            }
                        }
                        setFinalShowAmount(finalShowAmount - cAmount);
                        setInputCouponCode("");
                        setCuponCode(code);
                        setErrorText("");
                        setErrorText(false);
                        toast.success("Coupon Applied Successfull*", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
                        setCpnShow(false);
                    }
                } catch (error) {
                    toast.error("Coupon not Eligible for you*", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
                    setErrorText("Enter Correct Coupon Code*");
                    setCouponCode({});
                    removeCouponAmount("");
                }
            }
            else { setErrorText("Invalid coupon code*"); }
        }
        else { setErrorText("Enter Coupon Code*"); }
    };

    const clearCoupon = () => {
        setFinalShowAmount(finalShowAmount + couponAmount);
        setCuponCode("");
        removeCouponAmount("");
        setCouponCode({});
        setErrorText(false);
    };

    const getTaxApi = async () => {
        try {
            const res = await getTaxService();
            if (res) { setTax(res); }
        } catch (error) { console.log("Error in getTaxApi function.") }
    };

    const getCoupan = async () => {
        try {
            const res = await services.globalService.getCouponsByUser(userDetail?.id);
            if (res.status == 200) {
                const filterCpn = res.data.data?.filter(
                    (item) => new Date(item.expireAt) >= new Date() && new Date(item.startAt) <= new Date());
                setFetchCoupon(filterCpn);
            }
        } catch (error) { console.log("Error in getCoupon function.") }
    };

    useEffect(() => {
        const priceWithDiscount = hoterData.priceLast * 1.2;
        let fakePrice =
            priceWithDiscount *
            bookingData.room *
            daysDiffernceWithMinOne(checkinDate, checkOutDate);
        let calPrice =
            hoterData.priceLast *
            bookingData.room *
            daysDiffernceWithMinOne(checkinDate, checkOutDate);
        setFakePrice(fakePrice);
        if (mealPlan != "ep") {
            const amt =
                roomBreakFastPrice[mealPlan] *
                daysDiffernceWithMinOne(checkinDate, checkOutDate) *
                bookingData.adults;
            setBreakFastMoney(amt);
            setFinalShowAmount(Number(calPrice) + Number(amt));
        } else {
            setBreakFastMoney(0);
            if (breakFastMoney) { setFinalShowAmount(finalShowAmount - breakFastMoney); }
            else { setFinalShowAmount(calPrice - breakFastMoney); }
        }
    }, [hoterData, checkinDate, checkOutDate, bookingData, tax, mealPlan]);

    const mealPlanHandler = (value) => {
        if (mealPlan == value) {
            setMealPlan("ep");
            toast.warning("Meal Plan Removed from Your Booking", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        } else {
            setMealPlan(value);
            toast.success("Meal Plan Added to Your Booking", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        }
    };

    const checkinChangeHandler = (date) => {
        const selectedDate = moment(date);
        setCheckinDate(date);
        setCheckOutDate("");
        if (selectedDate.isSame(tomorrowMoment, "day")) {
            const dayAfterTomorrow = selectedDate.clone().add(1, "days");
            setCheckOutDate(dayAfterTomorrow.toDate());
        }
    };

    const handleCalendarOpen = () => { };
    const calenderHandl = useRef();

    const handleFocusClick = () => { setFocus("otherPersonName"); };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setAnotherPerson(isChecked);
        if (isChecked) { setTimeout(() => setFocus("otherPersonName"), 0); }
    };

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const handleInnerLogin = async (data) => {
        let mainPayload = { mobile: data.mobile };
        const res = await services.auth.userLogin(mainPayload);
        if (res.status == 200) {
            if (res?.data?.isNewUser == true) { setPayloadData({ name: data.fullName, email: data.email, mobile: data.mobile }); }
            else { setPayloadData({ name: res?.data?.data?.name, email: res?.data?.data?.email, mobile: res?.data?.data?.mobile }); }
            timerForOtp();
            if (res.data.isNewUser) { setShowScreen({ otpScreen: true, newuser: true }); }
            else { setShowScreen({ otpScreen: true, newuser: false }); }
        }
    }

    // function getHoursArray(checkIn, checkOut) {
    //     const allHours = Array.from({ length: 24 }, (_, i) =>
    //         `${i.toString().padStart(2, '0')}:00`
    //     );
    //     if (!checkIn || !checkOut) {
    //         return allHours;
    //     }
    //     const start = parseInt(checkIn.split(':')[0], 10);
    //     const end = parseInt(checkOut.split(':')[0], 10);
    //     // 👉 Get the current date & time
    //     const now = new Date();
    //     const currentHour = now.getHours();
    //     const currentMinute = now.getMinutes();
    //     // 👉 If it’s “today”, begin at the *next* full hour
    //     let minStart = start;
    //     const today = true; // replace with your own “is today” check if needed
    //     if (today) {
    //         const nextHour = currentMinute > 0 ? currentHour + 1 : currentHour;
    //         if (nextHour > minStart) {
    //             minStart = nextHour;
    //         }
    //     }
    //     const hours = [];
    //     for (let h = minStart; h <= end; h++) {
    //         hours.push(`${h.toString().padStart(2, '0')}:00`);
    //     }
    //     return hours;
    // }

    // function getHoursArray(checkIn, checkOut) {
    //     // ✅ defaults
    //     const startTime = checkIn && checkIn.trim() !== '' ? checkIn : '00:00';
    //     const endTime = checkOut && checkOut.trim() !== '' ? checkOut : '23:00';
    //     const allHours = Array.from({ length: 24 }, (_, i) =>
    //         `${i.toString().padStart(2, '0')}:00`
    //     );
    //     const start = parseInt(startTime.split(':')[0], 10);
    //     const end = parseInt(endTime.split(':')[0], 10);
    //     const now = new Date();
    //     const currentHour = now.getHours();
    //     const currentMinute = now.getMinutes();
    //     // Minimum start hour (rounded up if we’re already past current minute)
    //     let minStart = start;
    //     const nextHour = currentMinute > 0 ? currentHour + 1 : currentHour;
    //     if (nextHour > minStart) {
    //         minStart = nextHour;
    //     }
    //     const hours = [];
    //     for (let h = minStart; h <= end; h++) {
    //         hours.push(`${h.toString().padStart(2, '0')}:00`);
    //     }
    //     return hours;
    // }

    function getHoursArray(checkIn, checkOut) {
        const startTime = checkIn && checkIn.trim() !== '' ? checkIn : '00:00';
        const endTime = checkOut && checkOut.trim() !== '' ? checkOut : '23:00';
        const start = parseInt(startTime.split(':')[0], 10);
        const end = parseInt(endTime.split(':')[0], 10);
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        let minStart = start;
        const todayStr = moment().format("YYYY-MM-DD");
        if (checkToday == todayStr) {
            const nextHour = currentMinute > 0 ? currentHour + 1 : currentHour;
            if (nextHour > minStart) { minStart = nextHour; }
        }
        const hours = [];
        for (let h = minStart; h <= end; h++) { hours.push(`${h.toString().padStart(2, '0')}:00`); }
        return hours;
    }

    const [roomAvilablty, setRoomAvilablty] = useState({})
    const [checkToday, setCheckToday] = useState()

    useEffect(() => { setCheckToday(moment(checkinDate).format('YYYY-MM-DD')) }, [checkinDate])

    const handleCheckRoomAvilablty = async (value) => {
        setNewCheckinTime(String(value))
        let payload = {
            propertyId: hotelData?.propertyId,
            propertyRoomsCategoryId: 1,
            date: checkToday,
            bookingType: hotelData?.slot,
            startTime: value,
            duration: hotelData?.slot?.slice(0, 2)
        }
        const res = await services.property.checkRoomAvilabltyService(payload)
        if (res.data.status == true) {
            setRoomAvilablty(res?.data?.data)
            setTotalAvilableRoom(res?.data?.data?.availableRooms)
            if (res?.data?.data?.availableRooms == 0) { alert('No rooms available') }
        }
        return res?.data?.data
    }

    const checkFullDayRoomAvaility = async () => {
        const payload = {
            propertyId: hotelData?.propertyId,
            propertyRoomsCategoryId: [hotelData?.categoryId],
            fromDate: moment(checkinDate).format("YYYY-MM-DD"),
            toDate: moment(checkOutDate).format("YYYY-MM-DD")
        }
        const res = await services.property.checkFullDayAvilabltyService(payload)
        if (res.status == 200) { setAvailRooms(res?.data?.data[0]) }
    }

    useEffect(() => { checkFullDayRoomAvaility() }, [checkinDate, checkOutDate])

    function safeParse(value, fallback = {}) {
        if (value == null) return fallback;
        if (typeof value == 'object') return value;
        if (typeof value == 'string') {
            if (value.trim() == '') return fallback;
            try {
                return JSON.parse(value);
            } catch (err) {
                console.error('JSON parse failed:', err);
                return fallback;
            }
        }
        return fallback;
    }

    const mergeThreeHrSlotForDate = (statusData, priceData, date, slotRegularPrices, timePeriods) => {
        const statusSlots = statusData?.[date] || [];
        const priceSlots = priceData?.[date] || [];
        const timeSlots = timePeriods?.[date] || [];
        const slot = hotelData?.slot;
        const statusItem = statusSlots.find(s => s.slot === slot);
        const priceItem = priceSlots.find(p => p.slot === slot);
        const timeItem = timeSlots.find(t => t.slot === slot);
        const fallbackPrice = slotRegularPrices?.threeHrPrice;
        return {
            slot,
            status: statusItem ? statusItem.status : "Available",
            price: Number(priceItem?.price || fallbackPrice),
            checkIn: timeItem?.checkIn || null,
            checkOut: timeItem?.checkOut || null
        };
    };

    let threeHrStatus = safeParse(hotelData?.threeHrStatus, {});
    let threeHrOfferPrice = safeParse(hotelData?.threeHrOfferPrice, {});
    let slotRegularPrices = hotelData;
    let timePeriods = safeParse(hotelData?.threeHrCheckIn, {});
    const newData = { [checkToday]: mergeThreeHrSlotForDate(threeHrStatus, threeHrOfferPrice, checkToday, slotRegularPrices, timePeriods) };

    useEffect(() => { if (availRooms?.availableRooms == 0) { alert('No Room Available. Please change date') } }, [availRooms])

    return (
        <>
            <div className='bg-gray border-bottom pv-3 book-hotel-head'>
                <div className='container'>
                    <div className='row justify-content-between'>
                        <div className='col-lg-8'>
                            <h2 className='pb-0'>{hoterData.propertyName}</h2>
                            <div className='flex'>
                                <h4 className='text-light'>{hoterData.categoryName}</h4>
                                {/* <span className='btn-mat btn-mat-default rounded-1 mh-2'>Couple Friendly</span> */}
                            </div>
                            <p className='v-center text-secondary fs-6 pt-2'>
                                <IoLocationOutline size={18} className='mr-1' />
                                {hoterData.address}
                            </p>
                        </div>
                        <div className='col-lg-4'>
                            <div className='flex align-items-center justify-content-end'>
                                <a href="https://web.whatsapp.com/" target="_blank" className='btn btn-primary'>For Bulk Booking</a>
                                <img src='https://staging.rrooms.in/rrooms/uploads/IMG-20250531-WA0010-1748686216834.jpg' className='w-35 ml-4 rounded-1' title='' alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='pv-4'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-9'>
                            <div className='primary-panel book-hotel-main p-0'>
                                <div className='d-flex'>
                                    <div className='w-50 rounded-tl-1 bg-primary-light border-bottom  border-right border-primary p-3'>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-4 col-sm-4'>
                                                <p className='fs-7 fw-semibold'>Check-in</p>
                                                <h5><Moment format="DD/MM/YYYY">{checkinDate}</Moment></h5>
                                                {hotelData?.bookingType != "Hourly" && <p className='fs-7 fw-semibold'><Moment format="dddd">{checkinDate}</Moment>, 12 PM</p>}
                                            </div>
                                            <div className='col-lg-4 col-sm-4 text-center'>
                                                <span className='btn-mat btn-mat-secondary bg-white'>
                                                    {hotelData?.bookingType == "Hourly" ? hotelData?.slot : '1 NIGHT'}
                                                </span>
                                            </div>
                                            <div className='col-lg-4 col-sm-4'>
                                                <p className='fs-7 fw-semibold'>Check-in</p>
                                                <h5><Moment format="DD/MM/YYYY">{checkOutDate}</Moment></h5>
                                                {hotelData?.bookingType != "Hourly" && <p className='fs-7 fw-semibold'><Moment format="dddd">{checkOutDate}</Moment>, 11 AM</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='w-50 rounded-tr-1 bg-secondary-light border-bottom border-secondary all-center p-3'>
                                        <h4>
                                            {bookingData.adults ? bookingData.adults : 1} Adults |
                                            {bookingData.children ? bookingData.children : 0} children |
                                            {bookingData.room ? bookingData.room : 1} Room
                                        </h4>
                                    </div>
                                </div>
                                <div className='p-4'>
                                    {
                                        !access_token ? (
                                            <div className="pt-1 pb-3">
                                                <form className="row" onSubmit={handleSubmit(handleInnerLogin)}>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className='label'>Full Name</label>
                                                            <input
                                                                type="text"
                                                                {...register("fullName", { required: "Full name is required" })}
                                                                className="form-control form-control-sm"
                                                                placeholder="Enter Full name"
                                                            />
                                                            {errors.fullName && (
                                                                <p className="text-danger">{errors.fullName.message}</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className='label'>Email</label>
                                                            <input
                                                                type="email"
                                                                {...register("email", {
                                                                    required: "Email is required",
                                                                    pattern: {
                                                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                        message: "Enter a valid email",
                                                                    },
                                                                })}
                                                                placeholder="Enter Email"
                                                                className="form-control form-control-sm"
                                                            />
                                                            {errors.email && (
                                                                <p className="text-danger">{errors.email.message}</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className='label'>Mobile</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Enter Mobile"
                                                                className="form-control form-control-sm"
                                                                {...register("mobile", {
                                                                    required: "Mobile number is required",
                                                                    pattern: {
                                                                        value: /^\d{10}$/,
                                                                        message: "Please enter a valid 10-digit mobile number"
                                                                    }
                                                                })}
                                                            />
                                                            {errors.mobile && (
                                                                <p className="text-danger">{errors.mobile.message}</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className='label opacity-0'>Button</label>
                                                            <button type="submit" className="btn btn-primary btn-block">Verify</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        ) : null
                                    }

                                    {
                                        showScreen.otpScreen &&
                                        (
                                            <section className="verify-otp">
                                                <div className="title">OTP</div>
                                                <div className="title">Verification Code</div>
                                                <p className="m-0">
                                                    We have sent a verification code to your mobile number
                                                </p>
                                                <div className="edit-btn-area">
                                                    <span>{payloadData.phoneNumber}</span>
                                                    <button
                                                        className="btn m-0 p-0"
                                                        type="button"
                                                        onClick={() =>
                                                            setShowScreen({ newuser: false, otpScreen: false })
                                                        }
                                                    >
                                                        <FaRegEdit size={22} />
                                                    </button>
                                                </div>
                                                <form id="inputs" onSubmit={verifyHandler}>
                                                    <OTPInput
                                                        value={otp}
                                                        onChange={setOtp}
                                                        numInputs={4}
                                                        renderInput={(props) => (
                                                            <input
                                                                {...props}
                                                                type="number"
                                                                className="Otp-form-control"
                                                            />
                                                        )}
                                                    />
                                                    <button className="btn btn-secondary btn-sm mt-5 mb-3" type="submit">
                                                        Submit
                                                    </button>
                                                </form>
                                                {resendOtp ? (
                                                    <a
                                                        href="#"
                                                        className="termsparagraph m-0"
                                                        style={{ color: "#ff0018" }}
                                                        onClick={(e) => resendOTP(e)}
                                                    >
                                                        Resend OTP
                                                    </a>
                                                ) : (
                                                    <p className="m-0 termsparagraph">
                                                        Resend OTP in{" "}
                                                        {`00:${counter > 9 ? counter : `0${counter}`} `}
                                                    </p>
                                                )}
                                            </section>
                                        )
                                    }

                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className='row row-sm'>
                                            <div className='col-lg-2 col-sm-4'>
                                                <div className='form-group mb-0'>
                                                    <label className='label'>Room</label>
                                                    <div className="qty-handler">
                                                        <button
                                                            type="button"
                                                            onClick={() => changeCounts(false, 1, countRoom, setCountRoom, "room")}>
                                                            -
                                                        </button>
                                                        <input type='number' name="room" value={bookingData?.room} />
                                                        <button
                                                            type="button"
                                                            className="BtnUp"
                                                            onClick={() => changeCounts("up", 1, countRoom, setCountRoom, "room")} >
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-sm-4'>
                                                <div className='form-group mb-0'>
                                                    <label className='label'>Adults</label>
                                                    <div className="qty-handler">
                                                        <button
                                                            type="button"
                                                            onClick={() => changeCounts(false, 1, count, setCount, "adult")}>
                                                            -
                                                        </button>
                                                        <input type='number' name="room" value={bookingData.adults} />
                                                        <button
                                                            type="button"
                                                            className="BtnUp"
                                                            onClick={() => changeCounts("up", 1, count, setCount, "adult")} >
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-lg-2 col-sm-4'>
                                                <div className='form-group mb-0'>
                                                    <label className='label'>Child</label>
                                                    <div className="qty-handler">
                                                        <button
                                                            type="button"
                                                            onClick={() => changeCounts(false, 0, countChild, setCountChild, "child")}>
                                                            -
                                                        </button>
                                                        <input type='number' name="room" value={bookingData.children} />
                                                        <button
                                                            type="button"
                                                            className="BtnUp"
                                                            onClick={() => changeCounts("up", 0, countChild, setCountChild, "child")} >
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-sm-6">
                                                <div className='form-group mb-0'>
                                                    <label className='label'>Check in</label>
                                                    <DatePicker
                                                        className="form-control"
                                                        onChange={(date) => {
                                                            checkinChangeHandler(date);
                                                            calenderHandl?.current?.setOpen(true);
                                                        }}
                                                        selected={checkinDate}
                                                        dateFormat="dd/MM/yyyy"
                                                        minDate={new Date()}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                hotelData?.slot == '24' &&
                                                <div className="col-lg-3 col-sm-6">
                                                    <div className='form-group mb-0'>
                                                        <label className='label'>Check out</label>
                                                        <DatePicker
                                                            className="form-control"
                                                            name="checkout"
                                                            onChange={(date) => setCheckOutDate(date)}
                                                            selected={checkOutDate}
                                                            dateFormat="dd/MM/yyyy"
                                                            minDate={checkinDate ? new Date(new Date(checkinDate).setDate(new Date(checkinDate).getDate() + 1)) : tomorrowMoment.toDate()}
                                                            ref={calenderHandl}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                hotelData?.bookingType == "Hourly" && (
                                                    <div className='col-lg-3 col-sm-6'>
                                                        <div className='form-group mb-0'>
                                                            <label className='label'>Checkin Time</label>
                                                            <select
                                                                className="form-control"
                                                                // disabled={item?.status == "Sold-Out"}
                                                                // value={selectedTimes[i] || ""}
                                                                onChange={(e) => handleCheckRoomAvilablty(e.target.value)}
                                                                defaultValue={hotelData?.selectedCheckinTime}
                                                            >
                                                                <option value="">Select</option>
                                                                {
                                                                    getHoursArray(newData[checkToday]?.checkIn, newData[checkToday]?.checkOut).map((item) => {
                                                                        return (
                                                                            <option key={item}>{item}</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                totalAvilableRoom == 0 &&
                                                <div className="col-lg-12">
                                                    <p className="text-danger mt-2">No Room Available. Please select another checkin date or time.</p>
                                                </div>
                                            }
                                        </div>
                                        <div className="tabs mt-2">
                                            <ul className='tab-nav'>
                                                <li className="active">
                                                    <input
                                                        className="mr-1"
                                                        type="checkbox"
                                                        checked={anotherPerson}
                                                        onChange={(e) => {
                                                            handleCheckboxChange(e)
                                                            handleFocusClick()
                                                        }}
                                                    />
                                                    Book for Another Person
                                                </li>

                                                {
                                                    (roomBreakFastPrice.breakFastPrice > 0 || roomBreakFastPrice.ap || roomBreakFastPrice.map) &&

                                                    hotelData?.bookingType != "Hourly" &&
                                                    <li>
                                                        <input
                                                            type="checkbox"
                                                            className="mr-1"
                                                            id="breckFast"
                                                            onChange={() =>
                                                                setBreakFastCharge(!breakFastCharge)
                                                            }
                                                            value={breakFastCharge ? "checked" : "unchecked"}
                                                        />
                                                        Add Meal Plan
                                                    </li>
                                                }
                                            </ul>
                                            <div className="tab-content">
                                                {
                                                    anotherPerson ? (
                                                        <div className="tab-box">
                                                            <div className='row'>
                                                                <div className='col-lg-6'>
                                                                    <div className='form-group mb-0'>
                                                                        <label className='label'>Other Person Name</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="otherPersonName"
                                                                            {...register("otherPersonName", {
                                                                                required: "Please enter other person name",
                                                                                onChange: (e) => {
                                                                                    changeHandler(e);
                                                                                },
                                                                            })}
                                                                        />
                                                                        {errors.otherPersonName && (
                                                                            <p
                                                                                className="text-error"
                                                                                style={{ fontSize: '12px', color: '#f00' }}
                                                                            >{errors.otherPersonName.message}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className='col-lg-6'>
                                                                    <div className='form-group mb-0'>
                                                                        <label className='label'>Other Person Name</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="otherPersonNumber"
                                                                            {...register("otherPersonNumber", {
                                                                                required: "Please enter other person number",
                                                                                pattern: {
                                                                                    value: /^\d{10}$/,
                                                                                    message: "Please enter a valid 10-digit mobile number"
                                                                                },
                                                                                onChange: (e) => {
                                                                                    changeHandler(e);
                                                                                },
                                                                            })}
                                                                        />
                                                                        {errors.otherPersonNumber && (
                                                                            <p
                                                                                className="text-error"
                                                                                style={{ fontSize: '12px', color: '#f00' }}
                                                                            >{errors.otherPersonNumber.message}</p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : null
                                                }

                                                {breakFastCharge && (
                                                    <div className="mealPlan mt-2">
                                                        <div className="lables flex gap-2 align-items-center mb-2">
                                                            <input
                                                                type="checkbox"
                                                                name="mealPlan"
                                                                className="hotalMealPlane mr-1"
                                                                id="mealPlan1"
                                                                checked={mealPlan === "breakFastPrice"}
                                                                value="breakFastPrice"
                                                                onChange={(e) => mealPlanHandler(e.target.value)}
                                                            />
                                                            <label htmlFor="mealPlan1" className="m-0 fs-14">
                                                                CP
                                                            </label>
                                                            <small className="text-black">(Breakfast)</small>
                                                        </div>

                                                        <div className="lables flex gap-2 align-items-center mb-2">
                                                            <input
                                                                type="checkbox"
                                                                name="mealPlan"
                                                                className="hotalMealPlane mr-1"
                                                                id="mealPlan3"
                                                                checked={mealPlan === "map"}
                                                                value="map"
                                                                onChange={(e) => mealPlanHandler(e.target.value)}
                                                            />
                                                            <label htmlFor="mealPlan3" className="fs-14 m-0">
                                                                MAP
                                                            </label>
                                                            <small className="text-black">
                                                                (Breakfast + Lunch or Dinner)
                                                            </small>
                                                        </div>
                                                        <div className="lables flex gap-2 align-items-center mb-2">
                                                            <input
                                                                type="checkbox"
                                                                name="mealPlan"
                                                                className="hotalMealPlane mr-1"
                                                                id="mealPlan2"
                                                                checked={mealPlan === "ap"}
                                                                value="ap"
                                                                onChange={(e) => mealPlanHandler(e.target.value)}
                                                            />
                                                            <label htmlFor="mealPlan2" className="fs-14 m-0">
                                                                AP
                                                            </label>

                                                            <small className="text-black">
                                                                (Breakfast + Lunch + Dinner)
                                                            </small>
                                                        </div>
                                                    </div>
                                                )}
                                                {
                                                    breakFastMoney > 0 && breakFastCharge && (
                                                        <span>
                                                            + ₹ {roomBreakFastPrice?.[mealPlan]}
                                                            /Adult/Day
                                                        </span>
                                                    )}
                                            </div>
                                        </div>

                                        {
                                            availRooms?.availableRooms == 0 ? '' : (
                                                <div className="pt-2 pb-2 payment-options">
                                                    <h3 className='pb-3'>Payment method</h3>
                                                    <button
                                                        type="submit"
                                                        className="payment-button"
                                                    >
                                                        <div className='row text-center'>
                                                            <div className='col-lg-4'>
                                                                <div
                                                                    className={`column bg-primary-light border border-primary rounded-1 h-100 ph-3 pt-4 pb-1 ${selectedPayOptipn === "online" ? "active" : null}`}
                                                                    onClick={() => {
                                                                        setSelectedPayOptipn("online");
                                                                        setPaymentMethod('online')
                                                                    }}>
                                                                    <img src={ImagesData?.IconPayOnline} title='' alt='' />
                                                                    <h5 className='pt-2 pb-1'>Pay Now</h5>
                                                                    <p className='fs-7  pb-2'>Visa, MasterCard, Amex, Rupay and More</p>
                                                                    <img src={ImagesData?.PaymentOptions} title='' alt='' />
                                                                </div>
                                                            </div>
                                                            {
                                                                hoterData?.partialPayment == 1 && (
                                                                    <div className='col-lg-4'>
                                                                        <div
                                                                            className={`column bg-success-light border border-success rounded-1 h-100 ph-3 pt-4 pb-1 ${selectedPayOptipn === "parcialpay" ? "active" : null}`}
                                                                            onClick={() => {
                                                                                setSelectedPayOptipn("parcialpay");
                                                                                setPaymentMethod('parcialpay')
                                                                            }}>
                                                                            <img src={ImagesData?.IconPayPartial} title='' alt='' />
                                                                            <h5 className='pt-2 pb-1'>
                                                                                Pay @{
                                                                                    Math.floor(((finalShowAmount + (finalShowAmount * tax?.amount) / 100) * 25) / 100) == 0 ? 1 : Math.floor(((finalShowAmount + (finalShowAmount * tax?.amount) / 100) * 25) / 100)
                                                                                } to Book
                                                                            </h5>
                                                                            <p className='fs-7  pb-2'>Visa, MasterCard, Amex, Rupay and More</p>
                                                                            <img src={ImagesData?.PaymentOptions} title='' alt='' />
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            <div className='col-lg-4'>
                                                                <div
                                                                    className={`column bg-secondary-light border border-secondary rounded-1 h-100 ph-3 pt-4 pb-1 ${selectedPayOptipn === "PayatHotel" ? "active" : null}`}
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        setSelectedPayOptipn("PayatHotel");
                                                                        setPaymentMethod('PayatHotel')
                                                                    }}>
                                                                    <img src={ImagesData?.IconPayHotel} title='' alt='' />
                                                                    <h5 className='pt-2 pb-1'>Pay at Hotel</h5>
                                                                    <p className='fs-7  pb-2 pl-10 pr-10'>Enjoy the flexibility to pay at the hotel when you arrive.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                            )
                                        }
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className='primary-panel p-0'>
                                <div className='bg-primary-light border-bottom border-primary p-2 mb-1'>
                                    <h4>Price Details</h4>
                                </div>
                                <div className='p-2'>
                                    <p className='v-center fs-6 justify-content-between mb-3'>
                                        <span>Room Tariff /{bookingData.adults} Guest/Day</span>
                                        <span className='fw-bold text-gray'>₹ {fakePrice.toFixed(2)}</span>
                                    </p>
                                    <p className='v-center fs-6 justify-content-between mb-3'>
                                        <span>Instant discount</span>
                                        <span className='fw-bold text-secondary'>
                                            ₹ {Math.round(
                                                fakePrice - hoterData.priceLast * bookingData.room
                                            )?.toFixed(2)}{" "}
                                        </span>
                                    </p>
                                    <p className='v-center fs-6 justify-content-between mb-3'>
                                        <span></span>
                                        {/* <span className='fw-bold text-secondary'>{Math.round(finalShowAmount)}</span> */}
                                        <span className='fw-bold text-secondary'>
                                            ₹ {Math.round((Number(finalShowAmount) || 0))}
                                        </span>
                                    </p>
                                    <p className='v-center fs-6 justify-content-between mb-3'>
                                        <span>Taxes & Fee</span>
                                        {/* <span className='fw-bold text-gray'>{Math.round((finalShowAmount * tax?.amount) / 100)}</span> */}
                                        <span className='fw-bold text-gray'>
                                            ₹ {Number.isFinite(finalShowAmount) && Number.isFinite(tax?.amount)
                                                ? Math.round((finalShowAmount * tax.amount) / 100)
                                                : 0}
                                        </span>
                                    </p>
                                </div>
                                <div className='bg-secondary-light flex align-items-center justify-content-between border-top border-secondary p-3'>
                                    <div className='left'>
                                        <h5>Total Amount </h5>
                                        <p className='fs-7'>inclusive of all taxes</p>
                                    </div>
                                    <div className='right'>
                                        <h3 className='text-secondary'>
                                            ₹ {Math.round((Number(finalShowAmount) || 0) + ((Number(finalShowAmount) || 0) * (Number(tax?.amount) || 0)) / 100)}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Bookhotel;